import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useState } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { GridLoader } from "react-spinners";
import {TopBar} from '../components/topbar';
import { MenuContext } from "../context/MenuContext";
import { ApartmentModal } from "../components/apartment_modal";
import { ProductDetails } from "../components/product_details"
import { SendEmail } from "../components/send_email";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { IoSearch } from "react-icons/io5";


export default function ManageCustomers() {
    const navigate = useNavigate();
    const {logOutFunction} = useContext(UserContext);
    const [cookies] = useCookies();
    const [formFields, setFormFields] = useState({ range: "", order: "", order_by: "" });
    const [bookingList, setBookingList] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [offset, setOffset] = useState(0);
    const [pagination] = useState('');
    const { menuOpen, setMenuOpen } = useContext(MenuContext)
    const [showApartmentModal, setShowApartmentModal] = useState(false);
    const [pageData] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [showEmailModal, setShowEmailModal] = useState(false);
    const [showDetails, setShowDetails] = useState({});

    useEffect(() => {
        if (menuOpen) setMenuOpen(false);
        getData();
    }, [])

    useEffect(() => {
        getData();
    }, [offset, formFields?.range])

    function changePage(type) {
        if (type == "next") {
            setOffset(offset + 20);
        } else {
            setOffset(offset - 20);
        }
    }

    useEffect(() => {
        setOffset(0);
        getData();
    }, [formFields?.order])

    async function getData() {
        const formData = new FormData();
        // Object.entries(formFields).forEach(([key, value]) => {
        //   formData.append(key, value);
        // });
        formData.append('offset', offset);
        if (formFields?.order !== undefined) {
            formData.append('order', formFields?.order);
            formData.append('order_by', formFields?.order_by);
        }
        formData.append('range', formFields?.range);
        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/get_customers.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            setPageLoading(false)
            if (response.data.status) {
              setBookingList(response.data.records);
            } else {

            }
        } catch (error) {
          setPageLoading(false)
        }
    }

    async function searchData() {
        const formData = new FormData();
        Object.entries(formFields).forEach(([key, value]) => {
          formData.append(key, value);
        });
        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/get_customers.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            setPageLoading(false)
            if (response.data.status) {
              setBookingList(response.data.records);
            } else {

            }
        } catch (error) {
          setPageLoading(false)
        }
    }

  return (
    <div className="flex flex-col rounded-[10px] min-h-full bg-white">
      {showApartmentModal &&
            <ApartmentModal 
                setShowApartmentModal={setShowApartmentModal}
                getData={getData}
                pageData={pageData}
            />
      }
      {showModal &&
        <ProductDetails 
            setShowModal={setShowModal}
            showModal={showModal}
            showDetails={showDetails}
        />
        }
       {showEmailModal &&
        <SendEmail 
            setShowEmailModal={setShowEmailModal}
            showEmailModal={showEmailModal}
            showDetails={showDetails}
        />
        }
      {pageLoading && (
      <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] bg-[#ffffff] fixed opacity-[0.9]">
        <GridLoader
            color={'#7d5af6'}
            loading={true}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
      </div>
      )}
        {/* <h2 className="text-2xl text-[#037684] font-bold mb-4">Welcome, {userProfile?.name}</h2> */}
        <TopBar title={`Welcome, Admin`} />
        <div className="py-6 px-6 flex flex-col justify-start">
            <div className="flex gap-y-2 md:gap-y-0 mt-3 md:mt-0 flex-col md:flex-row items-start md:items-center justify-between">
                <div>
                    <h2 className="text-xl md:text-2xl text-black font-bold">{'Member Customers'}</h2>
                    <div className="flex items-center gap-x-2">
                        <p>Show: </p>
                        <select
                            className="w-auto mx-auto border p-2 rounded my-2"
                            onChange={(e) => setFormFields({...formFields, range: e.target.value})}
                        >
                            <option value="">All Time</option>
                            <option value="Today">Today</option>
                            <option value="Week">This Week</option>
                            <option value="Month">This Month</option>
                            <option value="Year">This Year</option>
                        </select>
                    </div>
                </div>
                <div className="flex items-center gap-x-2 self-end">
                    <div className="min-w-[30%] flex flex-col md:flex-row items-end md:items-center gap-y-2 md:gap-y-0 md:gap-x-2">
                        <div className="w-full flex items-center justify-between border rounded-xl p-1">
                            <input
                                type="text"
                                placeholder="Search name or email"
                                className="w-full bg-transparent focus:outline-none text-gray-700 px-2"
                                value={formFields?.search}
                                onChange={(e) => {setFormFields({...formFields, search: e.target.value}); }}
                            />
                            <button onClick={() => formFields?.search?.length > 0 ? searchData() : getData() } className="hover:opacity-[0.8] bg-primary text-white flex flex-row items-center justify-evenly w-auto h-[35px] px-3 rounded-xl shadow-md shrink-0 text-sm md:text-md">
                                <span className="text-white font-cormorant-bold text-sm md:text-md update-price"><IoSearch /></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className='overflow-x-auto mt-5'>
                <table className="w-full table-auto border-collapse text-sm md:text-[15px]">
                    <thead className="bg-gray-50 border-b">
                    <tr>
                        <th className="hidden md:table-cell px-2 py-4">
                            <div className="flex items-center gap-1">#</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex justify-between items-center gap-1">
                                Name
                                <div className="flex flex-col">
                                    <button onClick={() => setFormFields({...formFields, order_by: 'name', order: 'ASC'})} >
                                        <IoMdArrowDropup color={formFields?.order_by == "name" && formFields?.order == "ASC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                    <button onClick={() => setFormFields({...formFields, order_by: 'name', order: 'DESC'})}>
                                        <IoMdArrowDropdown color={formFields?.order_by == "name" && formFields?.order == "DESC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                </div>
                            </div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Email</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Phone</div>
                        </th>
                        <th className="hidden md:table-cell text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex justify-between items-center gap-1">
                                No. of Orders
                                <div className="flex flex-col">
                                    <button onClick={() => setFormFields({...formFields, order_by: 'no_of_sales', order: 'ASC'})} >
                                        <IoMdArrowDropup color={formFields?.order_by == "no_of_sales" && formFields?.order == "ASC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                    <button onClick={() => setFormFields({...formFields, order_by: 'no_of_sales', order: 'DESC'})}>
                                        <IoMdArrowDropdown color={formFields?.order_by == "no_of_sales" && formFields?.order == "DESC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                </div>
                            </div>
                        </th>
                        <th className="hidden md:table-cell text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex justify-between items-center gap-1">
                                Amount Spent
                                <div className="flex flex-col">
                                    <button onClick={() => setFormFields({...formFields, order_by: 'total_income', order: 'ASC'})} >
                                        <IoMdArrowDropup color={formFields?.order_by == "total_income" && formFields?.order == "ASC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                    <button onClick={() => setFormFields({...formFields, order_by: 'total_income', order: 'DESC'})}>
                                        <IoMdArrowDropdown color={formFields?.order_by == "total_income" && formFields?.order == "DESC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                </div>
                            </div>
                        </th>
                        <th className="hidden md:table-cell text-left px-2 py-4 font-medium text-gray-600"></th>
                    </tr>
                    </thead>
                    <tbody className="text-gray-700">
                        {bookingList?.map((row, index) => (
                            <tr
                            key={index}
                            className={index % 2 === 0 ? "bg-white animate-fadeIn" : "bg-gray-50 animate-fadeIn"}
                            >
                                <td className="hidden md:table-cell px-2 py-2">
                                    {++index}
                                </td>
                                <td className="px-2 py-2 font-semibold">
                                    {row.name}
                                </td>
                                <td className="px-2 py-2 font-semibold">
                                    {row.email}
                                </td>
                                <td className="px-2 py-2">
                                    {row.phone_number}
                                </td>
                                <td className="px-2 py-2">
                                    {row.no_of_sales}
                                </td>
                                <td className="text-[#00b47a] font-medium hidden md:table-cell px-2 py-2">
                                    {row.total_income}
                                </td>
                                <td className="px-2 py-2 gap-1">
                                    <div className="flex flex-col md:flex-row gap-y-1 md:gap-y-0 gap-x-1">
                                        <div onClick={() => { setShowDetails({ email: row.email, }); setShowModal(true) }} className="flex items-center justify-center cursor-pointer px-2 py-1 md:px-3 md:py-2 rounded-[5px] border border-1 border-[#037684] bg-[#037684] text-white font-semibold text-center text-xs">{'View Cart'}</div>
                                        {/* <div onClick={() => { setShowDetails({ email: row.email, }); setShowEmailModal(true) } } className="flex items-center justify-center cursor-pointer px-2 py-1 md:px-3 md:py-2 rounded-[5px] border border-1 border-[#037684] bg-[#037684] text-white font-semibold text-center text-xs">{'Send Email'}</div> */}
                                        <a onClick={() => navigate(`/dashboard/member-customers/orders/${row.customer_id}`, {state: {row}})} className="cursor-pointer underline text-secondary text-sm font-medium p-2">View</a>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className='w-full flex justify-end mt-6'>
                <div className='flex flex-col items-center'>
                    <div className="flex items-center space-x-2 border border-gray-300 rounded-lg px-1 py-1 w-fit bg-white">
                        <button
                            onClick={() => changePage('prev')}
                            className="text-sm font-semibold px-3 py-1 rounded bg-gray-100 hover:bg-gray-200"
                        >
                            Prev.
                        </button>
                        <button
                            onClick={() => changePage('next')}
                            className="text-sm font-semibold px-3 py-1 rounded bg-gray-100 hover:bg-gray-200"
                        >
                            Next
                        </button>
                    </div> 
                    <label className='text-sm mt-2'>{pagination}</label>
                </div>
            </div>
        </div>
    </div>
  );
}
